import React from 'react';
import ArrayX from 'shared/components/parameters/ArrayX';
import ArrayY from 'shared/components/parameters/ArrayY';
import ArrayUp from 'shared/components/parameters/ArrayUp';

const YesPanelized = props => (
  <div>
    <div className="row">
      <div className="col-md-6">
        <ArrayX {...props} />
      </div>
      <div className="col-md-6">
        <ArrayY {...props} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <ArrayUp {...props} />
      </div>
    </div>
  </div>
);

export default YesPanelized;
